import { FormattedMessage } from 'react-intl';

import { Column } from '@/flavours/glitch/components/column';
import { EmptyColumnHeader } from '@/flavours/glitch/components/column_header';
import { EmptyState } from '@/flavours/glitch/components/empty_state';
import { mascot } from '@/flavours/glitch/initial_state';
import elephantUIPlane from '@/images/elephant_ui_plane.svg';

const MultiColumnPlaceholderColumn: React.FC = () => {
  return (
    <Column>
      <EmptyColumnHeader />

      <div
        // Spacing element that pushes the EmptyState to the middle of the column
        style={{ flex: 0.75 }}
      />

      <EmptyState
        image={null}
        title={null}
        message={
          <FormattedMessage
            id='multi_column_placeholer.message'
            defaultMessage='Posts and other pages will open in this column.'
          />
        }
      />

      <div className='drawer__inner__mastodon'>
        <img alt='' draggable='false' src={mascot ?? elephantUIPlane} />
      </div>
    </Column>
  );
};

// eslint-disable-next-line import/no-default-export
export default MultiColumnPlaceholderColumn;
